import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
const shortTestimonials = [{
  quote: 'I used to build every session from scratch — two hours per client. Now I open the tome, pick the session, and I’m ready. I got my evenings back.',
  author: 'Sarah M.',
  role: 'Life Coach'
}, {
  quote: "My clients started telling me, 'I can tell you have a real method.' That never happened before. Four out of five renewed this quarter.",
  author: 'David R.',
  role: 'Transformation Coach'
}, {
  quote: 'I stopped digging through YouTube at midnight for exercises. The worksheet library alone is worth the whole price.',
  author: 'Jessica T.',
  role: 'Life Coach'
}];
const moreTestimonials = [{
  quote: 'Tome 3 is pure gold. My client came in stuck on procrastination and in two minutes I had the exact session for it.',
  author: 'Certified Coach'
}, {
  quote: 'The Session Zero script alone turned my free call into a paying client. Closed on the spot.',
  author: 'Coach'
}, {
  quote: 'What I use most: the scripts for the awkward moments. Talking about my rate doesn’t make me flinch anymore.',
  author: 'Coach'
}];
export function App() {
  return <div className="min-h-screen w-full bg-cream text-ink font-sans selection:bg-sage selection:text-white" data-id="element-0" data-mp="35ox2qy1z4t4">
      <MetaPixel data-id="element-1" data-mp="3ubrhck3tkg3z" />
      <main data-id="element-2" data-mp="3uc9jfxd5xojt">
        <Hero data-id="element-3" data-mp="3uevrdy3yu62k" />
        <SocialProofBar data-id="element-4" data-mp="3uf5g7id9y76o" />
        <Testimonials testimonials={shortTestimonials} background="white" data-id="element-5" data-mp="d57f31uekgij" />
        <PainGrid data-id="element-6" data-mp="85l3sxy4xacd" />
        <ProductReveal data-id="element-7" data-mp="851l3f0nuhxa" />
        <Tomes data-id="element-8" data-mp="86mc4unrniqe" />
        <Bonuses data-id="element-9" data-mp="86499f6lm69i" />
        <Urgency data-id="element-10" data-mp="83i0xdbvvmq8" />
        <Pricing data-id="element-11" data-mp="3glea6jyr55fp" />
        <ValueStack data-id="element-12" data-mp="3gkv1zuywlvev" />
        <Testimonials testimonials={moreTestimonials} title="More coaches, more results" background="cream" data-id="element-13" data-mp="3gmfsn9i3ku7g" />
        <Guarantee data-id="element-14" data-mp="3bkguce17snhd" />
        <Faq data-id="element-15" data-mp="3qbpo8zc5gv0b" />
        <CostOfInaction data-id="element-16" data-mp="3qbfud0nzi3pc" />
        <Close data-id="element-17" data-mp="3qcr0h74wjnjm" />
      </main>
      <Footer data-id="element-18" data-mp="3qd0st1df66sh" />
    </div>;
}